import React, { FC } from 'react';

import { useUser } from '@adsk/alloy-provider';
import { Flex, Text } from '@adsk/alloy-react-box';

import i18n from '../../utils/i18n';

const ProjectsHeaderTitles: FC = () => {
  const { user } = useUser();

  return (
    <Flex flexDirection="column">
      <Text data-testid="projectsTitle" typography="title" color="charcoal900">
        {`${i18n.t('WELCOME', { firstName: user?.firstName || '', interpolation: { escapeValue: false } })}`}
      </Text>

      <Text typography="heading2" color="charcoal700" mt="6px">
        {i18n.t('MY_HOME_SUBTITLE')}
      </Text>
    </Flex>
  );
};

export default ProjectsHeaderTitles;
